import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import { Loader2, FileWarning } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function LegalPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    setPage(null);
    setMissing(false);
    axios.get(`${API}/content`)
      .then((r) => {
        const found = (r.data.legal_pages || []).find((p) => p.slug === slug);
        if (found) setPage(found);
        else setMissing(true);
      })
      .catch(() => setMissing(true));
  }, [slug]);

  return (
    <div className="min-h-screen bg-cream px-4 py-14" data-testid="legal-page">
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}
        className="max-w-2xl mx-auto">
        <Link to="/"><img src="/logo.png" alt="Vowyo" className="h-9 w-auto mb-8" /></Link>

        {!page && !missing && <div className="text-center py-10"><Loader2 size={32} className="mx-auto text-pink animate-spin" /></div>}

        {missing && (
          <div className="rounded-3xl bg-white border-[3px] border-ink shadow-[6px_6px_0_#2D1A32] p-10 text-center">
            <FileWarning size={36} className="mx-auto text-tangerine" />
            <p className="mt-4 font-head font-semibold text-plum" data-testid="legal-missing">That page doesn't exist.</p>
          </div>
        )}

        {page && (
          <div className="rounded-3xl bg-white border-[3px] border-ink shadow-[6px_6px_0_#2D1A32] p-8 sm:p-10">
            <h1 className="font-display font-bold text-3xl sm:text-4xl" data-testid="legal-title">{page.title}</h1>
            <div className="mt-6 whitespace-pre-wrap text-sm sm:text-[15px] text-plum font-medium leading-relaxed" data-testid="legal-body">
              {page.body}
            </div>
          </div>
        )}

        <Link to="/" data-testid="legal-back-home" className="mt-6 inline-block text-xs font-mono text-lilac underline underline-offset-4 hover:text-pink transition-colors">
          ← Back to Vowyo
        </Link>
      </motion.div>
    </div>
  );
}
